import { render, staticRenderFns } from "./HighScoresScreen.vue?vue&type=template&id=52f59780"
import script from "./HighScoresScreen.vue?vue&type=script&lang=js"
export * from "./HighScoresScreen.vue?vue&type=script&lang=js"
import style0 from "./HighScoresScreen.vue?vue&type=style&index=0&id=52f59780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports